import { Component} from '@angular/core';
import { NgxLinkifyjsService } from 'ngx-linkifyjs';

import {NotificationService} from '../shared/notification.service';
import {UserSettingsService} from '../shared/user-settings.service';

@Component({
    selector: 'notifications-component',
    templateUrl: 'notifications.component.html'
})
export class NotificationsComponent {
    constructor(public linkService: NgxLinkifyjsService, public userSettings: UserSettingsService, public notifyService: NotificationService) {}
}